"use client";

import styles from "@/styles/modules/components/homepage/module2.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Content from "../Content";
import { ContentComponent } from "@/types/modules";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "@/context/languageContext";

interface Module2Props {
  homepageOptions: HomepageOptions;
}

export default function Module2({ homepageOptions }: Module2Props) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en" ? homepageOptions.module2 : homepageOptions.module2DE
  );

  useEffect(() => {
    setData(
      language === "en" ? homepageOptions.module2 : homepageOptions.module2DE
    );
  }, [homepageOptions.module2, homepageOptions.module2DE, language]);

  const content: ContentComponent = {
    imageAlign: data.contentFields.imageAlign,
    textAlign: data.contentFields.textAlign,
    content: data.contentFields.body,
    gallery: data.contentFields.gallery,
    sameWidth: true,
    button: data.contentFields.button,
    ...(data.contentFields.title && {
      title: data.contentFields.title,
    }),
  };

  return (
    <section
      className={styles.module2}
      style={{
        backgroundColor: data.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.module2Container} data-aos="fade-in">
        {data.optionsHomepageModule2.title && (
          <h2>{data.optionsHomepageModule2.title}</h2>
        )}
        <Content content={content} />
      </div>
    </section>
  );
}
